import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';

import './NotFound.scss';

export default function NotFoundIndex() {
  const history = useHistory();

  useEffect(() => {
    history.replace('404');
  }, [history]);

  return (
    <div className="not-found">
      <h1 className="header">Page Not Found</h1>
      <div className="description">
        <p>You entered an invalid route.</p>
      </div>
    </div>
  );
}
